/**
 * A barra de filtros entre a faixa e a tabela.
 *
 * Papel: reproduz `.toolbar` e `.toolbar .spacer` (l. 153–162, 182) — `flex`
 * que quebra linha, `gap` de 10 px, fundo branco e borda só dos lados, para a
 * faixa de cima e a tabela de baixo fecharem o contorno.
 *
 * Como usar: os filtros entram como filhos diretos, um item do `flex` cada; o
 * `FiltroDePeriodo` da base devolve um fragmento justamente para os seus quatro
 * elementos entrarem assim. O `Espacador` empurra o que vem depois dele para a
 * direita.
 */
import { type ReactNode } from 'react';

/**
 * A barra de filtros.
 *
 * @param children - Os filtros e os botões, na ordem da origem.
 * @returns A barra.
 */
export function BarraDeFiltros({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-2.5 border-x border-emb-borda bg-superficie px-4 py-3">
      {children}
    </div>
  );
}

/**
 * O espaço elástico da barra.
 *
 * @returns Um elemento vazio com `flex:1`.
 */
export function Espacador() {
  return <div aria-hidden="true" className="flex-1" />;
}
